



















import { Component, Vue, Watch } from 'vue-property-decorator';
import { applicationsDetail } from '@/permissions/index';
@Component({
  name: 'IndexTab',
})
export default class extends Vue {

  get showApplicationsDetail() {
    return applicationsDetail() || true;
  }

  public tabs = ['index', 'studentQuery', 'applicationList' ]
  public activeIndex: number = 0; // 当前选中的tab的index

  @Watch('$route.name', { immediate: true })
  public onRouteNameChange(newVal: string) {
    this.activeIndex = this.tabs.findIndex((itemName: string) => itemName === newVal);
    const activeTabRouteNames = [ 'studentInformation' ]
    if (this.activeIndex === -1 && activeTabRouteNames.includes(newVal)) {
      this.activeIndex = 1;
    }
  }

  public clickTab(tabIndex: number, page: string) {
    if (tabIndex === this.activeIndex) {
      return;
    }
    this.activeIndex = tabIndex;
    this.$emit('tab-change', page);
  }
}
